import { render, staticRenderFns } from "./ApproverBidForm.vue?vue&type=template&id=30138550"
import script from "./ApproverBidForm.vue?vue&type=script&lang=js"
export * from "./ApproverBidForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports